import { FormLabel } from "@mui/material";
import { HTMLInputTypeAttribute } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ERROR_TYPE, translateError } from "@/utils";

interface IFormTextField {
	label?: string;
	errorMessage?: string;
	startAdornment?: JSX.Element;
	endAdornment?: JSX.Element;
	containerClassName?: string;
	formRegister?: UseFormRegisterReturn;
	inputClassName?: string;
	autoComplete?: string;
	type?: HTMLInputTypeAttribute;
	placeHolder?: string;
	required?: boolean;
	showLabel?: boolean;
	multiline?: boolean;
}

export default function FormTextField({
	label,
	errorMessage,
	startAdornment,
	containerClassName,
	formRegister,
	autoComplete,
	type,
	placeHolder,
	required = true,
	endAdornment,
	inputClassName,
	showLabel = true,
	multiline = false,
}: IFormTextField) {
	const { t } = useTranslation();

	return (
		<div className={`space-y-1 mb-4 w-full relative ${containerClassName}`}>
			{showLabel && (
				<FormLabel
					component="label"
					sx={{
						color: "#11110F",
						fontSize: "14px",
						fontWeight: "500",
					}}
				>
					{label} {!!required && <span className="text-red-500">*</span>}
				</FormLabel>
			)}
			<div className="relative">
				{startAdornment && (
					<div className="absolute left-3 top-1/2 transform -translate-y-1/2">{startAdornment}</div>
				)}
				{!multiline ? (
					<input
						{...(formRegister ?? {})}
						autoComplete={autoComplete}
						className={`w-full rounded-xl p-[13px] border border-border focus:outline-none focus:ring-2 focus:ring-primary-blue text-primary-blue-dark font-urbanist font-normal ${
							errorMessage ? "border-red-500" : ""
						} text-[14px] leading-4 ${inputClassName} ${
							type === "password" ? "font-serif" : "font-urbanist"
						} placeholder:font-urbanist`}
						placeholder={placeHolder ?? t("basics.enterSomething", { something: label })}
						style={{
							paddingLeft: !!startAdornment ? "2.5rem" : "13px",
							paddingRight: endAdornment ? "2.5rem" : "13px",
						}}
						type={type}
					/>
				) : (
					<textarea
						{...(formRegister ?? {})}
						autoComplete={autoComplete}
						className={`w-full rounded-xl p-[13px] border border-border focus:outline-none focus:ring-2 focus:ring-primary-blue text-primary-blue-dark font-urbanist font-normal ${
							errorMessage ? "border-red-500" : ""
						} text-[14px] leading-4 ${inputClassName} ${
							type === "password" ? "font-serif" : "font-urbanist"
						} placeholder:font-urbanist`}
						placeholder={placeHolder ?? t("basics.enter-your") + label}
						style={{
							paddingLeft: !!startAdornment ? "2.5rem" : "13px",
							paddingRight: endAdornment ? "2.5rem" : "13px",
						}}
					/>
				)}
				{endAdornment && (
					<div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-danger">
						{endAdornment}
					</div>
				)}
			</div>
			{errorMessage && (
				<p className="absolute -bottom-5 text-[12px] text-danger">
					{translateError[errorMessage as unknown as ERROR_TYPE] ?? errorMessage}
				</p>
			)}
		</div>
	);
}
